skrilla.controller('downloadProductReportsModalCtrl', function ($scope, cacheService, $timeout, searchService, productFeeReportService, productIntegrityReportService) {
    $scope.headers = []
    $scope.data = cacheService.getObject("productReportsBulkExportData");
    $scope.exports = [];
    $scope.data.reports.forEach(function(report){
        var tag = report.tag;
        var start = new Date(report.calculationStartAt)
        var end = new Date(report.calculationEndAt)
        //AP Wants the name to look like it finished at 23:59:59 for reports
        // just run with it
        end.setDate(end.getDate() - 1)
        let reportType = $scope.data.type === "fee" ? "" : report.reportType !== undefined && report.reportType !== null ? "-" + report.reportType : "";
        report.csvName = tag +reportType+"-" + start.getDate() + "-" + (start.getMonth() + 1) + "-to-" + end.getDate()  + "-" + (end.getMonth() + 1);
        report.csvDownloaded = false;
        $scope.exports.push({headers: []})
    });

    //allow button to render
    $timeout(function(){
        download(0);
    })

    function download(i){
        if(i < $scope.data.reports.length){
            let report = $scope.data.reports[i];
            let url = $scope.data.type === "fee" ? "productFeeReports/" : "productIntegrityReports/"
            let service = $scope.data.type === "fee" ? productFeeReportService : productIntegrityReportService;
            searchService.get(url + report.id, null).then(function(response){
                $scope.report = response.data;
                $scope.exports[i].tableData = service.buildTableForEntries($scope.report.tag, $scope.report.entries, $scope.report.reportType, $scope.report.version);
                $scope.exports[i].filename = report.csvName;
                $scope.clickExportToCsvButton(i);
                report.csvDownloaded = true;
            })
        }
    }

    $scope.clickExportToCsvButton = function(i){
        $timeout(function(){
            document.getElementById("downloadCsvButton" + i).click();
            console.log("clicked", i)
            $timeout(function() {
                console.log($scope.tableData)
                console.log("download", i);
                download(i + 1);
            }, 500);
        }, 500)
    }

});
